<div class="properties-container">
    <button mat-icon-button class="close-button" (click)="closePanel()" matTooltip="Close" aria-label="Close the run model panel">
        <mat-icon class="close-icon">close</mat-icon>
    </button>

    <h2 mat-dialog-title>Run model</h2>
    <p class="intro">Simulates items arriving at the captures and flowing through the model. Each action takes its set duration, limited by the capacity of the people in its roles. Changes here only affect the simulation, not the model.</p>

    @if (errorMessages.length > 0) {
        <h3>Check these first</h3>
        <p class="intro">These nodes are missing details the simulation needs. Select one to go to it.</p>
        <ul class="problems">
        @for (m of errorMessages; track m.node._key) {
            <li><button type="button" class="problem" (click)="selectNode(m.node._key)"><span class="problem-name">{{m.node.name || 'Unnamed node'}}</span><span class="problem-message">{{m.message}}</span></button></li>
        }
        </ul>
    }
    <h3>Inputs</h3>
    <p class="intro">How many items arrive at each capture per year.</p>
    @if (inputs.length === 0) {
        <p class="intro">This view has no captures, so nothing arrives to simulate.</p>
    }
    @for (input of inputs; track input.node.tag.node._key) {
        <div class="inputs-container">
            <h4>{{input.name}}</h4>
            <mat-form-field color="accent">
                <mat-label>Inputs per year</mat-label>
                <input matInput type="number" min="0" step="1" [(ngModel)]="input.itemsPerYear" [disabled]="animationService.isRunning">
            </mat-form-field>
        </div>
    }
    <h3>Roles</h3>
    <p class="intro">Change the number of people in a role to see how its capacity affects the flow.</p>
    @for (role of roles; track role._key) {
        <div class="roles-container">
            <h4>{{role.name}}</h4>
            <mat-form-field color="accent">
                <mat-label>Num people</mat-label>
                <input matInput type="number" min="0" step="1" [(ngModel)]="role.number" [disabled]="animationService.isRunning">
            </mat-form-field>
            <mat-form-field color="accent">
                <mat-label>Model capacity</mat-label>
                <input matInput type="number" [ngModel]="Math.round(role.capacity*role.number)" disabled="true">
            </mat-form-field>
            <mat-form-field color="accent">
                <mat-label>Total capacity</mat-label>
                <input matInput type="number" [ngModel]="Math.round(role.orgCapacity*role.number)" disabled="true">
            </mat-form-field>
        </div>
    }

    @if (statistics) {
        <h3>Statistics</h3>
        <div class="outputs-container">
            <mat-form-field color="accent">
                <mat-label>Ticks</mat-label>
                <input matInput type="text" [value]="statistics.tick" readonly>
            </mat-form-field>
            <mat-form-field color="accent">
                <mat-label>Elapsed time</mat-label>
                <input matInput type="text" [value]="getElapsedTime()" readonly>
            </mat-form-field>
            <mat-form-field color="accent">
                <mat-label>Model time</mat-label>
                <input matInput type="text" [value]="getModelMinutes(statistics.tick)" readonly>
            </mat-form-field>
            <mat-form-field color="accent">
                <mat-label>Inputs received</mat-label>
                <input matInput type="number" [value]="statistics.received" readonly>
            </mat-form-field>
        </div>
        <h3>Outputs</h3>
        <p>The following shows the number of outputs processed and the time taken to process the last item (from start to finish)</p>
        @for (output of statistics.outputs; track output._key) {
            <div class="outputs-container">
                <h4>{{output.name}}</h4>
                <mat-form-field color="accent">
                    <mat-label>Outputs produced</mat-label>
                    <input matInput type="number" [value]="output.processed" readonly>
                </mat-form-field>    
                <mat-form-field color="accent">
                    <mat-label>Model time taken</mat-label>
                    <input matInput type="text" [value]="getModelMinutes(output.ticks)" readonly>
                </mat-form-field>
                <mat-form-field color="accent">
                    <mat-label>Time without delay</mat-label>
                    <input matInput type="text" [value]="showTime(output.nodelaySeconds/60)" readonly>
                </mat-form-field>                
            </div>
        }
    }

    @if (maxSlider > 1) {
        <h3>{{slider.value}} model minute{{slider.value === '1' ? '' : 's'}} per second</h3>
        <p>Adjust the slider to change how many model minutes occur every real second. Maximum has been set to the lowest action duration which is {{maxSlider}} minutes.</p>
        <mat-slider
            class="example-margin"
            [disabled]="animationService.isRunning"
            [max]="maxSlider"
            [min]="1"
            [step]="1"
            [discrete]="true"
            [showTickMarks]="true">
        <input matSliderThumb [(ngModel)]="minutesPerSecond" #slider>
        </mat-slider>
    }@else {
        <h3>{{maxSlider}} model minute{{maxSlider == 1 ? '' : 's'}} per second</h3>
    }
    <div class="action-buttons">
        <button mat-button (click)="closePanel()">Close</button>
        <button mat-stroked-button matTooltip="Clear the results and the queues on the canvas" (click)="clearResults()" [disabled]="animationService.isRunning">
            <mat-icon>restart_alt</mat-icon>Clear
        </button>
        <button mat-flat-button color="accent" (click)="toggleModel()" [disabled]="!animationService.isRunning && inputs.length === 0">
            <mat-icon>{{animationService.isRunning ? 'stop' : 'play_arrow'}}</mat-icon>{{animationService.isRunning?'Stop':'Start'}}
        </button>
    </div>
</div>